<template>
  <div class="headassembly">
    <div class="headassembly_left">
      <h2>
        <p>风湿免疫专病智能分析管理平台</p>
      </h2>
      <div class="headassembly_div">
        <ul>
          <li v-for="(item, index) in navList" :key="index" @click="navItem(item, index)"
            :class="{ headassemblybackground: menuindex == index + 1 }">
            <img :src="item.url" alt />
            <p>{{ item.navName }}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="headassembly_right">
      <!-- <div style="margin-top: 8px;" class="right_margin">
        <el-dropdown>
                <span class="el-dropdown-link" style="font-size: 16px">
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  @click.native="changeFontSize('0')">小</el-dropdown-item>
            <el-dropdown-item  @click.native="changeFontSize('1')">中</el-dropdown-item>
            <el-dropdown-item  @click.native="changeFontSize('2')">大</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>-->
      <div class="system_right">
        <el-button type="info" plain style="
            width: 128px;
            height: 36px;
            border-radius: 138px;
            position: relative;
          " @click="Switchingsystem" disabled>
          <span style="
              bottom: 8px;
              position: absolute;
              right: 20px;
              font-size: 16px;
              color: #909399;
            ">科研系统</span>
        </el-button>
      </div>
      <div @click="news" style="
          margin-top: 8px;
          margin-left: 2px;
          display: flex;
          margin-right: 6px;
          cursor: pointer;
        ">
        <el-badge :value="newsList.length" class="item">
          <img src="../assets/image/notice/lingdang.png" alt style="width: 18px; height: 18px; margin-top: 2px" />
        </el-badge>
      </div>
      <div class="padClass" style="margin-top: 10px; cursor: pointer" @click="SystemSettings" v-if="admin == '00000000-0000-0000-0000-000000000000' || RoleType == 'D'
        ">
        <img src="../assets/image/notice/setting.png" alt style="width: 18px; height: 18px" />
      </div>
      <el-tooltip class="item padClass" effect="dark" :content="UnitName" placement="top">
        <div style="margin-top: 8px">
          <span style="margin-left: 4px">{{ UnitName | ellipsis }}</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="UserName + TitleName" placement="top">
        <div style="margin-right: 40px; margin-top: 5px" class="UserName">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link" style="display: flex; margin-bottom: 4px">
              <img :src="Sex == '1'
                  ? require('../assets/image/30nan.png')
                  : require('../assets/image/30nv.png')
                " alt style="margin-right: 5px" />
              <div style="margin-top: 2px">
                <span style="font-size: 16px; margin-bottom: 10px" class="zhuren">{{ (UserName + TitleName) | ellipsis
                }}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item>个人中心</el-dropdown-item> -->
              <el-dropdown-item @click.native="SwitchOrganization"
                v-if="admin == '00000000-0000-0000-0000-000000000000'">切换组织</el-dropdown-item>
              <el-dropdown-item @click.native="editPasswordDialog = true">修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="LogOut">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-tooltip>
    </div>
    <div class="edit-password">
      <el-dialog top="25vh" :visible.sync="editPasswordDialog">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age">修改密码</span>
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="原始密码" prop="pwd">
            <el-input type="password" v-model="ruleForm.pwd" autocomplete="off" show-password
              placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input type="password" v-model="ruleForm.pass" autocomplete="off" show-password
              placeholder="请输入6到20位之间的密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" show-password
              placeholder="请输入6到20位之间的密码"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <button type="button" @click="cancelEditPswDialog">取消</button>
              <button type="button" @click="submitForm">确定</button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <div class="SwitchOrganization">
      <el-dialog :visible.sync="dialogVisible" width="30%">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age">切换组织</span>
        </div>
        <div>
          <span style="margin-left: 40px; font-size: 16px; margin-right: 10px">选择组织</span>
          <span style="display: inline-block; width: 350px; margin-bottom: 10px">
            <el-select v-model="OrganizationId" placeholder="请选择" value-key="Id">
              <el-option v-for="(item, index) in organization" :key="index" :label="item.Name" :value="item"></el-option>
            </el-select>
          </span>
        </div>
        <div class="btn">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="determine">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="news">
      <el-dialog :visible.sync="NewsdialogVisible" width="50%">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age">消息列表</span>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="消息列表" name="first">
            <el-table :data="newsList" border :header-cell-style="{ background: 'rgb(240, 247, 253)' }"
              style="width: 100%; margin-bottom: 10px">
              <el-table-column align="center" prop="TriggerTime" label="发送日期" width="180"></el-table-column>
              <el-table-column align="center" prop="UserName" label="参研人员" width="180"></el-table-column>
              <el-table-column align="center" prop="MsgContent" label="消息内容"></el-table-column>
              <el-table-column align="center" prop="address" label="是否处理">
                <template slot-scope="scope">
                  <p>{{ scope.row.IsHandled == true ? "已处理" : "未处理" }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="待办任务" name="second">
            <el-table :data="ToDoTasks" :header-cell-style="{ background: 'rgb(240, 247, 253)' }" border
              style="width: 100%">
              <el-table-column align="center" prop="ChannelName" label="任务方式"></el-table-column>
              <el-table-column align="center" prop="Count" label="数量"></el-table-column>
              <el-table-column align="center" label="操作" width="180">
                <template slot-scope="scope">
                  <el-link :underline="false" @click="ViewTasks(scope.row)">
                    <i class="el-icon-edit-outline"></i>查看
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <!-- <div  class="btn">
          <el-button @click="NewsdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="NewsdialogVisible = false">确 定</el-button>
        </div>-->
      </el-dialog>
    </div>
    <div>
      <el-dialog :visible.sync="VdialogVisible" fullscreen width="100%">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age">任务列表</span>
        </div>
        <div class="loading_table_head" style="margin-bottom: 20px">
          <span style="display: inline-block; width: 300px; margin-right: 10px">
            <el-input v-model="input" placeholder="请输入内容"></el-input>
          </span>
          <el-button type="primary" icon="el-icon-search">搜索</el-button>
        </div>
        <div style="margin-bottom: 10px">
          <el-table border :data="VtableData" :header-cell-style="{ background: 'rgb(240, 247, 253)' }"
            style="width: 100%; height: 600px; margin-bottom: 20px">
            <el-table-column align="center" prop="ProjectName" label="项目名称" width="280"></el-table-column>
            <el-table-column align="center" prop="QuestionnaireName" label="问卷名称" width="280"></el-table-column>
            <el-table-column align="center" prop="TargetName" label="患者姓名" width="100"></el-table-column>
            <el-table-column align="center" prop="TargetTel" label="患者手机" width="140"></el-table-column>
            <el-table-column align="center" prop="TriggerTime" label="随访日期" width="200"></el-table-column>
            <el-table-column align="center" prop="UserName" label="主管医生" width="200"></el-table-column>
            <el-table-column align="center" prop="UserTel" label="主管电话" width="200"></el-table-column>
            <el-table-column align="center" prop="ChannelName" label="随访方式"></el-table-column>
            <el-table-column align="center" prop="StatusName" label="状态"></el-table-column>
            <el-table-column prop="Frq" label="访视次数" align="center"></el-table-column>
            <el-table-column align="center" fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-link @click="handleClick(scope.row)" type="text" :underline="false" style="margin-right: 11px">
                  <i class="el-icon-search"></i>填写问卷
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <Pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.rows"
              @pagination="MyMissionDetailed"></Pagination>
          </div>
        </div>
        <div class="btn">
          <el-button @click="VdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="VdialogVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="QuestionnaireFilling">
      <el-dialog :visible.sync="QuestionnaireFillingDialog" fullscreen>
        <iframe :src="Url" frameborder="0" width="100%" height="1080px" ref="myFrame"></iframe>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { session, local } from "@/utils/storage";
import { mapState } from "vuex";
import administrators from "../api/administrators";
import Statistics from "../api/Statistics";
import login from "../api/login";
import Pagination from "../components/Pagination/index.vue";
export default {
  data() {
    var validatePwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value !== this.PwdPlainText) {
        callback(new Error("密码不正确"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      total: 0,
      Sex: local.get("Sex"),
      Channel: null,
      input: "",
      Url: "",
      PwdPlainText: "sq1123123",
      QuestionnaireFillingDialog: false,
      VtableData: [],
      listQuery: {
        Key: "",
        page: 1,
        rows: 10,
      },
      VdialogVisible: false,
      ToDoTasks: [],
      activeName: "first",
      NewsdialogVisible: false,
      dialogVisible: false,
      OrganizationName: local.get("OrganizationName"),
      navList: [
        {
          path: "/statistics",
          navName: "数据概览",
          url: require("../assets/image/icon/data-statistics1.png"),
        },
        {
          path: "/dataCenterNav",
          navName: "数据中心",
          url: require("../assets/image/icon/a333.png"),
        },
        {
          path: "/HomePage",
          navName: "项目管理",
          url: require("../assets/image/icon/project-management1.png"),
        },
        {
          path: "/patentList",
          navName: "患者中心",
          url: require("../assets/image/icon/a222.png"),
        },
        {
          path: "/smartSearch",
          navName: "智能搜索",
          url: require("../assets/image/icon/a222.png"),
        },
        {
          path: "/dataAnalyst",
          navName: "数据分析",
          url: require("../assets/image/icon/a333.png"),
        },
        {
          path: "/questionnaire",
          navName: "问卷中心",
          url: require("../assets/image/icon/questionnaire-enter1.png"),
        },
        {
          path: "/repository",
          navName: "知识库",
          url: require("../assets/image/icon/questionnaire-enter1.png"),
        },
        // {
        //   path: "/questionnaire",
        //   navName: "任务排队管理",
        //   url: require("../assets/image/icon/questionnaire-enter1.png"),
        // },

        // {
        //   path: "/DataCenter",
        //   navName: "已收集问卷",
        //   url: require("../assets/image/icon/patient-list1.png"),
        // },

        // {
        //   path: "/derive",
        //   navName: "查询导出",
        //   url: require("../assets/image/icon/query-export.png"),
        // },
        // {
        //   path: "/task",
        //   navName: "随访任务",
        //   url: require("../assets/image/icon/follow-up-task.png"),
        // },
        // {
        //   path: "/report",
        //   navName: "工作汇报",
        //   url: require("../assets/image/icon/work-report.png"),
        // },
        // {
        //   path: "/RobotCenter",
        //   navName: "机器人中心",
        //   url: require("../assets/image/icon/a333.png"),
        // },
      ],
      UserName: local.get("UserName") || "",
      UnitName: local.get("UnitName") || "",
      TitleName:
        local.get("TitleName") !== "undefined" ? local.get("TitleName") : "",
      admin: local.get("UserId"),
      RoleType: local.get("RoleType"),
      //是否显示设置信息
      message: false,
      editPasswordDialog: false,
      ruleForm: {
        pwd: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        pwd: [
          { validator: validatePwd, trigger: "blur" },
          { min: 1, max: 20, message: "密码不能为空" },
        ],
        pass: [
          { validator: validatePass, trigger: "blur" },
          { min: 6, max: 20, message: "密码在6到20位之间" },
        ],
        checkPass: [
          { validator: validatePass2, trigger: "blur" },
          { min: 6, max: 20, message: "密码在6到20位之间" },
        ],
      },
      organization: [],
      OrganizationId: {
        Id: "",
      },
      newsList: [],
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 5) {
        return value.slice(0, 5) + "...";
      }
      return value;
    },
  },
  computed: mapState(["menuindex"]),
  created() {
    this.GetUserMy();
    if (session.get("menuindex")) {
      this.$store.commit("menustate", session.get("menuindex"));
    } else {
      this.$store.commit("menustate", 1);
    }
  },
  components: {
    Pagination,
  },
  methods: {
    //获取个人信息
    async GetUserMy() {
      const { data } = await administrators.GetUserMy();
      if (data.Status == 1) {
        this.PwdPlainText = data.Data.BasePart.PwdPlainText;
      }
    },
    //修改个人信息
    async KeepUserMy() {
      let parameter = {
        OldPwd: this.ruleForm.pwd,
        NewPwd: this.ruleForm.pass,
        ConfirmPwd: this.ruleForm.checkPass,
      };
      const { data } = await administrators.KeepUserMy(parameter);
      if (data.Status == 1) {
        this.$message({
          message: data.Message,
          type: "success",
        });
        this.LogOut();
      }
    },
    handleClick(item) {
      this.Url = "";
      // const parameter={
      //     ProjectId:item.ProjectId
      // }
      // questionnaire.CallBackQuestionnaireData(parameter).then(res=>{
      //              console.log(res);
      //             if(res.data.Status==1){
      //                   let sysData=JSON.parse(res.data.Data)
      //                   sysData['FollowUpTaskId']=item.Id
      //                   sysData['FillType']='D'

      //                   this.QuestionnaireFillingDialog=true
      //                   this.Url=`${window.global_config.BASE_URL1}/#/P?sysData=${JSON.stringify(sysData)}&type=1&qid=${item.ProjectQuestionnaireId}&userId=${item.TargetId}&userName=${item.UserName}&fillinId=${local.get('UserId')}&fillinName=${local.get('UserName')}&phone=${item.TargetTel}&visitsNumber=${item.Frq}`
      //             }else{
      //                 alert(res.data.Message+"++++++")
      //             }
      // })
      if (this.VtableData && this.VtableData[0].CallBackInfo.IsSuccess) {
        this.QuestionnaireFillingDialog = true;
        this.Url = `${window.global_config.BASE_URL1}/#/P?sysData=${this.VtableData[0].CallBackInfo.CallBackParameterEncrypt
          }&type=1&qid=${item.ProjectQuestionnaireId}&userId=${item.TargetId
          }&userName=${item.UserName}&fillinId=${local.get(
            "UserId"
          )}&fillinName=${local.get("UserName")}&phone=${item.TargetTel
          }&visitsNumber=${item.Frq}`;
      }
    },
    ViewTasks(item) {
      this.VdialogVisible = true;
      this.Channel = item.Channel;
      this.MyMissionDetailed();
    },
    MyMissionDetailed() {
      const parameter = {
        Key: this.listQuery.Key,
        page: this.listQuery.page,
        rows: this.listQuery.rows,
        Channel: this.Channel,
      };
      login.MyMissionDetailedData(parameter).then((res) => {
        if (res.data.Status == 1) {
          this.total = res.data.Data.total;
          this.VtableData = res.data.Data.rows;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //我的任务
    MyMission() {
      login.MyMissionData().then((res) => {
        if (res.data.Status == 1) {
          this.ToDoTasks = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },
    news() {
      this.NewsdialogVisible = true;
      Statistics.NewsListData().then((res) => {
        if (res.data.Status == 1) {
          this.newsList = res.data.Data;
        } else {
          alert(res.data.message);
        }
      });
      this.MyMission();
    },
    determine() {
      local.set("OrganizationName", this.OrganizationId.Name);
      local.set("currentOrganizationId", this.OrganizationId.Id);
      // local.set("UserName",this.OrganizationId.Name)
      this.dialogVisible = false;
      this.$store.commit("menustate", 1);
      this.$router.push("/EmptyPage");
    },
    //组织
    NoPagingOrganization() {
      const parameter = {
        Key: "",
      };
      administrators.NoPagingOrganizationData(parameter).then((res) => {
        if (res.data.Status == 1) {
          this.organization = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //切换组织
    SwitchOrganization() {
      this.OrganizationId.Id = local.get("currentOrganizationId");
      this.NoPagingOrganization();
      this.dialogVisible = true;
    },
    //系统设置
    SystemSettings() {
      this.$router.push({ name: "navber" });
    },
    Switchingsystem() { },
    //退出登录
    LogOut() {
      this.$router.push("/");
      session.clear();
      local.clear();
      location.reload();
    },
    //提交密码
    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          await this.KeepUserMy();
          this.editPasswordDialog = false;
        } else {
          return false;
        }
      });
    },
    //取消
    cancelEditPswDialog() {
      this.$refs.ruleForm.resetFields();
      this.editPasswordDialog = false;
    },
    changeFontSize(size) {
      window.document.documentElement.setAttribute("data-size", size);
    },
    navItem(item, index) {
      // console.log(item.path)
      local.set("IsRtc", true);
      this.$store.commit("menustate", index + 1);
      this.$router.push(item.path);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/mixin.scss";

.QuestionnaireFilling {
  /deep/.el-dialog__headerbtn {
    top: 3px;
    font-size: 24px;
  }
}

.news {
  /deep/.el-dialog__body {
    padding: 0px 20px 20px;
  }
}

.SwitchOrganization {
  /deep/.el-input__inner {
    width: 350px;
  }
}

.headassembly {
  width: 1920px;
  height: 100%;

  .headassembly_left {
    width: 1420px;
    height: 100%;
    float: left;
    box-shadow: 0 3px 0 rgba(0, 104, 163, 0.1);

    h2 {
      width: 400px;
      height: 100%;
      float: left;
      display: table;
      padding-left: 35px;
      box-sizing: border-box;

      img {
        margin-left: 22px;
        margin-top: 12px;
        margin-right: -10px;
        vertical-align: middle;
      }

      p {
        display: table-cell;
        vertical-align: middle;
        font-size: 26px;
        color: #333333;
        line-height: 40px;
      }
    }

    .headassembly_div {
      width: 1010px;
      height: 100%;
      float: left;

      ul {
        width: 1010px;
        height: 100%;
        overflow: hidden;

        li {
          width: 96px;
          height: 80%;
          text-align: center;
          float: left;
          border-radius: 4px;
          cursor: pointer;
          margin-top: 6px;
          margin-left: 10px;

          img {
            width: 24px;
            height: 24px;
            margin-top: 6px;
          }

          p {
            font-size: 16px;
            color: #69696a;
          }
        }
      }
    }
  }

  .headassembly_right {
    width: 500px;
    height: 100%;
    float: left;
    display: flex;
    justify-content: space-between;
    padding-top: 23px;
    box-shadow: 0 3px 0 rgba(0, 104, 163, 0.1);
    box-sizing: border-box;

    // .right_margin {
    //   margin-left: 100px;
    // }
    /deep/.el-dropdown-menu {
      .el-dropdown-menu__item {
        padding: 0 10px;
      }
    }
  }
}

.headassemblybackground {
  background: linear-gradient(180deg, #5f7ffe 0%, #a5bdff 100%);

  p {
    color: #ffffff !important;
  }
}

.edit-password {
  /deep/ .el-dialog {
    width: 578px;

    .el-form {
      .el-form-item {
        .el-form-item__label {
          @include add-size($font_size_16);
          color: #666666;
        }
      }
    }
  }
}

.dialog_add {
  /deep/ .el-dialog {
    width: 1200px;
  }
}

.radio-dian {
  width: 7px;
  height: 7px;
  background: #f94747;
  border: 1px solid #ffffff;
  border-radius: 50%;
  margin-top: 1px;
  opacity: 1;
}

.content {
  ::-webkit-scrollbar {
    width: 8px !important;
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #1890ff;
    border-radius: 10px;
  }
}

.block {
  margin-top: 10px;
}

.notice-details /deep/.el-input {
  @include add-size($font_size_16);
  border: 0;
}

.notice-details /deep/.el-textarea {
  @include add-size($font_size_16);
  border: 0;
}

@media screen and (min-width: 1200px) and (max-width: 1560px) {
  .headassembly {
    width: 1440px;

    .headassembly_left {
      width: 940px;

      h2 {
        width: 340px;
        padding-left: 10px;
      }

      .headassembly_div {
        width: 600px;

        ul {
          width: 600px;
          height: 100%;
          overflow: hidden;

          li {
            width: 64px;
          }
        }
      }
    }

    .headassembly_right {
      width: 500px;

      .right_margin {
        margin-left: 0;
      }

      .system_right {
        margin-right: 0;
      }

      .UserName {
        margin-right: 0px !important;
      }
    }
  }
}

@media screen and (-webkit-min-device-pixel-ratio: 1.5) {
  .headassembly {
    width: 100%;
    display: flex;

    .el-dropdown-link {
      align-content: center !important;

      .zhuren {
        font-size: 14px !important;
      }
    }

    li {
      margin-left: 0 !important;

      p {
        font-size: 14px !important;
      }
    }

    .headassembly_left {
      width: 83%;

      .headassembly_div {
        width: 100%;
      }

      ul {
        display: flex;
        width: 100% !important;

        li {
          flex: 1;
        }

        li:nth-child(9) {
          display: none;
        }
      }
    }

    .headassembly_right {
      // width: 15%;
      flex: 1;

      .system_right {
        display: none;
      }

      .el-badge {
        // display: none;
      }

      img {
        width: 25px;
        height: 25px;
      }

      // :nth-child(2){
      //   display: none;
      // }
      .padClass {
        // display: none;
      }

      // :nth-child(5){
      //   display: none;
      // }
      .UserName {
        margin: 0 !important;
      }
    }

    h2 {
      display: none !important;
    }
  }
}
</style>
